import type { GridProps } from '@chakra-ui/react';
import { Box } from '@chakra-ui/react';
import { gridConfig } from '@time-line/components/common';

const { gridGapClamp } = gridConfig;

const dividerSvg = '/images/dividerOpacity.svg';

interface TableRowProps extends GridProps {
  productsCount: number;
  isDividerVisible?: boolean;
}

export function TableRow({
  productsCount,
  sx,
  isDividerVisible,
  ...props
}: TableRowProps) {
  const hasMoreThanFourProducts = productsCount > 4;
  const full = `repeat(${productsCount}, 1fr)`;
  const partial = `23.5% repeat(${productsCount}, 1fr)`;

  return (
    <Box
      as="tr"
      py="2xs"
      display="grid"
      gridTemplateColumns={{
        base: full,
        lg: hasMoreThanFourProducts ? full : partial,
      }}
      gap={gridGapClamp}
      sx={
        isDividerVisible
          ? {
              backgroundImage: `url(${dividerSvg})`,
              backgroundRepeat: 'repeat-x',
              backgroundSize: '6px 2px',
              backgroundPosition: 'top left',
              ...sx,
            }
          : {}
      }
      {...props}
    />
  );
}
